import type { ReactNode } from 'react'
import { FlexContainer } from '@/components'
import LanguageSelector from '@/components/layout/language-menu/LanguageSelector'
import * as styles from './HeaderCenteredContent.styles'

interface Props {
  logo: ReactNode
}

const HeaderCenteredContent = ({ logo }: Props) => (
  <FlexContainer
    align="center"
    css={[styles.headerCenteredContent]}
    justify="center"
  >
    {logo}

    <div css={[styles.headerContentActionBtns]}>
      <LanguageSelector />
    </div>
  </FlexContainer>
)

export default HeaderCenteredContent
